import React, { useState } from 'react'
import { 
    // Layout, 
    Menu, 
    Row, 
    Col, 
    Image, 
    Modal,
    Button,
} from 'antd';
import { useNavigate } from "react-router-dom";
import { Link } from 'react-router-dom';
import HeaderImage from "../../Assets/Images/AMBRE-LOGO-AMBER-WHITE.png"
import {
    // MenuFoldOutlined,
    // MenuUnfoldOutlined,
    CloseOutlined,
    UnorderedListOutlined,
} from '@ant-design/icons';
import { 
    Gite, 
    Villa, 
    AccountBox, 
    Feed,
    EmojiTransportation,
    // Logout, 
    // Badge,  
    Paid, 
    // PointOfSale, 
    Person,
    VpnKey,
    StackedBarChart,
    ReceiptLong,  
    Storefront,
    // ZoomOutMap,
    Payment,
    AssignmentInd,
    ListAlt,
    // Article,
    Groups3,
    Dashboard,
    MeetingRoom,
} from '@mui/icons-material';
import { ExclamationCircleOutlined } from "@ant-design/icons";
import { getUserRole, refreshPage } from '../../Utils/Common';
import { logout } from "../../Utils/api/Auth";
import toast from 'react-hot-toast';
const { SubMenu } = Menu;

function Navbar(props){
    const navigate = useNavigate();
    const role_name = getUserRole();
    const [isHovered, setIsHovered] = useState(false);
    const [subMenu, setSubMenu] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [
        modal, 
        contextHolder
    ] = Modal.useModal();

    const toggleCollapsed = () => {
      setIsHovered(!isHovered);
    };

    async function handleLogout() {
        setIsLoading(true);
        const response = await logout();
        if (response.data){
           localStorage.removeItem('token');
            localStorage.removeItem('user_id');
            localStorage.removeItem('full_name');
            localStorage.removeItem('role_id');
            localStorage.removeItem('role_name');
            localStorage.removeItem('token_expiry');
            setTimeout(()=>{
                navigate("/");
                refreshPage();
            }, 500)
          } else {
            toast.error(response.error.messages.error_messages.message)
          }
        
        setIsLoading(false);
    }
    
    const confirm = () => {
        modal.confirm({
          title: "Are you sure you want to logout?",
          icon: <ExclamationCircleOutlined />,
          content: "",
          okButtonProps: { isLoading },
          okText: "Logout",
          cancelText: "Cancel",
          onOk: handleLogout,
        });
    };

    const handleMouseEnter = () => {
        setIsHovered(true);
    };

    const handleToggleSub = (key) => {
        setSubMenu((prevOpenKeys) =>
          prevOpenKeys.includes(key) ? prevOpenKeys.filter((k) => k !== key) : [...prevOpenKeys, key]
        );
    };

    const handleTabKey = (key) => {
        localStorage.removeItem('start_date');
        localStorage.removeItem('end_date');
        localStorage.removeItem('tabkey');
        localStorage.removeItem('status');
        localStorage.removeItem('property_id');
        localStorage.removeItem('owner_id');
        localStorage.removeItem('rental_unit_id');
    };

    const handleMouseLeave = () => {
        setIsHovered(false);
        setSubMenu('')
    };
    
    // const handleSubEnter = (sub_menu) => {
    //     setSubIsHovered(true);
    //     setSubMenu(sub_menu)
    // };

    // const handleSubLeave = () => {
    //     setSubIsHovered(false);
    //     setSubMenu('')
    // };
    // const handleMenuSelect = (key) => {
    //     setActiveTab(key);
    // };
   
    return (
        <>
            <Row className='toggle-navbar'>
                <Col span={24} align='right'>
                    <Button
                        type="primary"
                        onClick={toggleCollapsed}
                        className={isHovered ? 'm-1 toggle-btn cancel-btn' : 'm-1 toggle-btn'}
                    >
                        {isHovered ? <CloseOutlined/> : <UnorderedListOutlined />}
                    </Button>
                </Col>
            </Row>
            <div 
                className={isHovered ? 'navbar-container-hovered responsive-overflow-y' : 'navbar-container navbar-page responsive-overflow-y'}
                onMouseEnter={handleMouseEnter}
                onMouseLeave={handleMouseLeave}
            >
                <Row className='mb-2' style={{background: 'var(--dominant-color)'}}>
                    <Col span={24} className='center'>
                        <Image
                            width="40%" 
                            height="auto" 
                            src={HeaderImage}
                            alt="login-image"
                            preview={false}
                            // className='mt-4 mb-3'
                        />
                    </Col>
                </Row>
                <Row 
                    className={isHovered ? 'overflow-y responsive-overflow-y nav-height' : 'nav-height overflow'}
                >
                    <Col span={24}>
                        <Menu
                            mode="inline"
                            selectedKeys={props.navKey ? [props.navKey] : []}
                            openKeys={subMenu}
                            onClick={handleTabKey}
                            inlineCollapsed={!isHovered}
                            className='navbar-menu'
                        >
                            <Menu.Item key="dashboard_nav" icon={<Dashboard />} className='center'>
                                <Link className='link-container' to="/dashboard"><span>Dashboard</span></Link>
                            </Menu.Item>
                            <Menu.Item key="property_nav" icon={<Villa />} className='center'>
                                <Link className='link-container' to="/property"><span>Property</span></Link>
                            </Menu.Item>
                            <SubMenu 
                                key="unit_sub_nav" 
                                icon={<Gite />} 
                                title="Rental Unit"  
                                // onMouseEnter={() => handleSubEnter('meter_sub_nav')} 
                                // onMouseLeave={handleSubLeave}
                                onTitleClick={() => handleToggleSub('unit_sub_nav')}
                            >
                                <Menu.Item key="unit_manager_nav" className='center'>
                                    <Link className='link-container' to="/rental-unit"><span>Unit Manager</span></Link>
                                </Menu.Item>
                                <Menu.Item key="unit_history_nav">
                                    <Link className='link-container' to="/rental-unit/history"><span>Unit History</span></Link>
                                </Menu.Item>
                            </SubMenu>  
                            <SubMenu 
                                key="parking_sub_nav" 
                                icon={<EmojiTransportation />} 
                                title="Parking"  
                                // onMouseEnter={() => handleSubEnter('meter_sub_nav')} 
                                // onMouseLeave={handleSubLeave}
                                onTitleClick={() => handleToggleSub('parking_sub_nav')}
                            >
                                <Menu.Item key="parking_manager_nav" className='center'>
                                    <Link className='link-container' to="/parking"><span>Parking Manager</span></Link>
                                </Menu.Item>
                                <Menu.Item key="parking_history_nav">
                                    <Link className='link-container' to="/parking/history"><span>Parking History</span></Link>
                                </Menu.Item>
                            </SubMenu>  
                            {/* <Menu.Item key="tenant_nav" icon={<Badge />} className='center'>
                                <Link className='link-container' to="/tenant"><span>Tenant</span></Link>
                            </Menu.Item> */}
                            <SubMenu 
                                key="contract_sub_nav" 
                                icon={<Feed />} 
                                title="Tenant Contracts"  
                                // onMouseEnter={() => handleSubEnter('meter_sub_nav')} 
                                // onMouseLeave={handleSubLeave}
                                onTitleClick={() => handleToggleSub('contract_sub_nav')}
                            >
                                <Menu.Item key="unit_contract_nav" className='center'>
                                    <Link className='link-container' to="/tenant"><span>Tenant Unit</span></Link>
                                </Menu.Item>
                                <Menu.Item key="parking_contract_nav">
                                    <Link className='link-container' to="/parking-contract"><span>Tenant Parking</span></Link>
                                </Menu.Item>
                            </SubMenu>  
                            <Menu.Item key="owner_nav" icon={<Person />} className='center'>
                                <Link className='link-container' to="/owner"><span>Owner</span></Link>
                            </Menu.Item>
                            {/* <Menu.Item key="security_deposits_nav" icon={<PointOfSale />} className='center'>
                                <Link className='link-container' to="/security-deposit"><span>Security Deposit</span></Link>
                            </Menu.Item> */}
                            <Menu.Item key="advance_rentals_nav" icon={<VpnKey />} className='center'>
                                <Link className='link-container' to="/advance-rental"><span>Advance Rental</span></Link>
                            </Menu.Item>
                            <Menu.Item key="construction_bonds_nav" icon={<Groups3 />} className='center'>
                                <Link className='link-container' to="/construction-bond"><span>Construction Bond</span></Link>
                            </Menu.Item>
                            <SubMenu 
                                key="meter_sub_nav" 
                                icon={<StackedBarChart />} 
                                title="Meter Readings"  
                                // onMouseEnter={() => handleSubEnter('meter_sub_nav')} 
                                // onMouseLeave={handleSubLeave}
                                onTitleClick={() => handleToggleSub('meter_sub_nav')}
                            >
                                <Menu.Item key="electricity_reading_nav">
                                    <Link className='link-container' to="/electric-reading"><span>Electricity Reading</span></Link>
                                </Menu.Item>
                                <Menu.Item key="water_reading_nav">
                                    <Link className='link-container' to="/water-reading"><span>Water Reading</span></Link>
                                </Menu.Item>
                                <Menu.Item key="gas_reading_nav">
                                    <Link className='link-container' to="/gas-reading"><span>Gas Reading</span></Link>
                                </Menu.Item>
                            </SubMenu>  
                            <SubMenu 
                                key="billing_sub_nav" 
                                icon={<ReceiptLong />} 
                                title="Billing" 
                                onTitleClick={() => handleToggleSub('billing_sub_nav')}
                                // onMouseEnter={() => handleSubEnter('billing_sub_nav')} 
                                // onMouseLeave={handleSubLeave}
                            >
                                <Menu.Item key="billings_nav">
                                    <Link className='link-container' to="/billing"><span>Tenant Billing</span></Link>
                                </Menu.Item>
                                <Menu.Item key="owners_billings_nav">
                                    <Link className='link-container' to="/owner-billing"><span>Owner Billing</span></Link>
                                </Menu.Item>
                                <Menu.Item key="parkings_billings_nav">
                                    <Link className='link-container' to="/parking-billing"><span>Parking Billing</span></Link>
                                </Menu.Item>
                                <Menu.Item key="billing_items_nav">
                                    <Link className='link-container' to="/billing-item"><span>Item</span></Link>
                                </Menu.Item>
                                <Menu.Item key="discount_item_nav">
                                    <Link className='link-container' to="/discount-item"><span>Item Discount</span></Link>
                                </Menu.Item>
                            </SubMenu>  
                            <SubMenu 
                                key="payment_sub_nav" 
                                icon={<Payment />} 
                                title="Payment" 
                                onTitleClick={() => handleToggleSub('payment_sub_nav')}
                                // onMouseEnter={() => handleSubEnter('billing_sub_nav')} 
                                // onMouseLeave={handleSubLeave}
                            >
                                <Menu.Item key="tenant_payment_nav">
                                    <Link className='link-container' to="/tenant-payment"><span>Tenant Payment</span></Link>
                                </Menu.Item>
                                <Menu.Item key="owner_payment_nav">
                                    <Link className='link-container' to="/owner-payment"><span>Owner Payment</span></Link>
                                </Menu.Item>
                                <Menu.Item key="parking_payment_nav">
                                    <Link className='link-container' to="/parking-payment"><span>Parking Payment</span></Link>
                                </Menu.Item>
                            </SubMenu>  
                            {/* <SubMenu key="exhibit_sub_nav" icon={<ZoomOutMap />} title="Exhibitors" onMouseEnter={() => handleSubEnter('exhibit_sub_nav')} onMouseLeave={handleSubLeave}>
                                <Menu.Item key="exhibitors_nav">
                                    <Link className='link-container' to="/exhibitor"><span>Exhibitors</span></Link>
                                </Menu.Item>
                                <Menu.Item key="exhibitors_billing_nav">
                                    <Link className='link-container' to="/exhibitor-billing"><span>Exhibitors Billing</span></Link>
                                </Menu.Item>
                                <Menu.Item key="exhibitors_payment_nav">
                                    <Link className='link-container' to="/exhibitor-payment"><span>Exhibitors Payments</span></Link>
                                </Menu.Item>
                            </SubMenu>  */}
                            {/* <Menu.Item key="payments_nav" icon={<Payment />} className='center'>
                                <Link className='link-container' to="/payments"><span>Payments</span></Link>
                            </Menu.Item> */}
                            <Menu.Item key="supplier_nav" icon={<Storefront />} className='center'>
                                <Link className='link-container' to="/supplier"><span>Supplier</span></Link>
                            </Menu.Item>
                            <SubMenu 
                                key="expense_sub_nav" 
                                icon={<Paid />} 
                                title="Expense"  
                                onTitleClick={() => handleToggleSub('expense_sub_nav')}
                            >
                                <Menu.Item key="expenses_nav" className='center'>
                                    <Link className='link-container' to="/expense"><span>Unit Expense</span></Link>
                                </Menu.Item> 
                                <Menu.Item key="parking_expenses_nav" className='center'>
                                    <Link className='link-container' to="/parking-expense"><span>Parking Expense</span></Link>
                                </Menu.Item> 
                            </SubMenu>  
                            <SubMenu 
                                key="tenant_report_sub_nav" 
                                icon={<AssignmentInd />} 
                                title="Report" 
                                onTitleClick={() => handleToggleSub('tenant_report_sub_nav')}
                                // onMouseEnter={() => handleSubEnter('tenant_report_sub_nav')} 
                                // onMouseLeave={handleSubLeave}
                            >
                                <Menu.Item key="monthly_collection_nav">
                                    <Link className='link-container' to="/monthly-collection"><span>Monthly Collection</span></Link>
                                </Menu.Item>
                                <Menu.Item key="monthly_payment_nav">
                                    <Link className='link-container' to="/monthly-payment"><span>Monthly Payment</span></Link>
                                </Menu.Item>
                                <Menu.Item key="receivable_report_nav">
                                    <Link className='link-container' to="/receivable-report"><span>Open Bills</span></Link>
                                </Menu.Item>
                                <Menu.Item key="owner_income_nav">
                                    <Link className='link-container' to="/owner-income"><span>Owner Income</span></Link>
                                </Menu.Item>
                                {
                                    role_name === "Administrator" && (
                                        <Menu.Item key="management_income_nav">
                                            <Link className='link-container' to="/management-income"><span>Management Income</span></Link>
                                        </Menu.Item>
                                    )
                                }
                            </SubMenu>
                            <SubMenu 
                                key="task_report_sub_nav" 
                                icon={<ListAlt />} 
                                title="Task Manager" 
                                onTitleClick={() => handleToggleSub('task_report_sub_nav')}
                                // onMouseEnter={() => handleSubEnter('tenant_report_sub_nav')} 
                                // onMouseLeave={handleSubLeave}
                            >
                                <Menu.Item key="personnel_task_nav">
                                    <Link className='link-container' to="/task-personnel"><span>Personnel</span></Link>
                                </Menu.Item>
                                <Menu.Item key="category_task_nav">
                                    <Link className='link-container' to="/task-category"><span>Category</span></Link>
                                </Menu.Item>
                                <Menu.Item key="task_manager_nav">
                                    <Link className='link-container' to="/task-manager"><span>Task Manager</span></Link>
                                </Menu.Item>
                                <Menu.Item key="task_calendar_nav">
                                    <Link className='link-container' to="/task-calendar"><span>Calendar</span></Link>
                                </Menu.Item>
                            </SubMenu>    
                            {/* <SubMenu key="exhibit_report_sub_nav" icon={<Article />} title="Exhibitors Report" onMouseEnter={() => handleSubEnter('exhibit_report_sub_nav')} onMouseLeave={handleSubLeave}>
                                <Menu.Item key="exhibitors_payment_report">
                                    <Link className='link-container' to="/exhibitor-payment-report"><span>Exhibitors Payment</span></Link>
                                </Menu.Item>
                                <Menu.Item key="exhibitors_receivable_report">
                                    <Link className='link-container' to="/exhibitor-receivable-report"><span>Exhibitors Receivable</span></Link>
                                </Menu.Item>
                            </SubMenu>   */}
                            <Menu.Item key="user_nav" icon={<AccountBox />} className='center'>
                                <Link className='link-container' to="/user"><span>User</span></Link>
                            </Menu.Item>
                            <Menu.Item 
                                key="login" 
                                icon={<MeetingRoom className='logout-icon'/>} 
                                onClick={confirm} 
                                className='center logout-button logout-res' 
                                align='bottom'
                                disabled={isLoading}
                            >
                                <span>Logout</span>
                            </Menu.Item>
                        </Menu>
                    </Col>
                </Row>
                <Row className='logout-container'>
                    <Col span={24}>
                        <Menu
                            mode="inline"
                            // className='logout-button'
                        >
                           <Menu.Item 
                                key="login" 
                                icon={<MeetingRoom className='logout-icon'/>} 
                                onClick={confirm} 
                                className='center logout-button' 
                                align='bottom'
                                disabled={isLoading}
                            >
                                <span>Logout</span>
                            </Menu.Item>
                            {contextHolder}
                        </Menu>
                    </Col>
                </Row>
            </div>
        </>
    )
}

export default Navbar
